'use client';
import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

export default function TermsDialog({
  isOpen,
  close,
  content,
}: {
  isOpen: boolean;
  close: () => void;
  content: any;
}) {
  return (
    <Dialog open={isOpen} as="div" className="dialog_terms" onClose={close}>
      <div className="inner pad dim">
        <DialogPanel transition>
          <div className="wrap_terms">
            <DialogTitle as="h3" className="title">
              {content?.title}
            </DialogTitle>
            <div className="content" dangerouslySetInnerHTML={{ __html: content?.content }}></div>
          </div>
          <div className="group_btn">
            <Button
              className="btn_primary"
              onClick={() => {
                close();
              }}
            >
              닫기
            </Button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
